import { render, staticRenderFns } from "./BuildSection.vue?vue&type=template&id=4cdc64a9"
import script from "./BuildSection.vue?vue&type=script&lang=ts"
export * from "./BuildSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports